<template>
<div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
        <img src="@/assets/images/HoltEstateLogowhite.png" class="mx-auto mb-2 max-w-full custom-logo-size">
        <h6 class="sm:mx-0 m-base mb-6 text-xl text-white">Please wait while we log you in</h6>
        <vs-terms></vs-terms>
        <h6 class="sm:mx-0 m-base mb-6 text-xl text-white">Version: {{ currentVersion }}</h6>
    </div>
</div>
</template>

<script>
import * as Msal from "@azure/msal-browser";

import {
    BaseConfig
} from '../../store/api/config'

import {
    version
} from '../../../package.json';

export default {
    data() {
        return {
            currentVersion: version,
        }
    },
    created() {
        this.setupClientApplication();
    },
    methods: {
        setupClientApplication() {
            this.app = new Msal.PublicClientApplication({
                auth: {
                    clientId: `${BaseConfig.AppClientID}`,
                    authority: `${BaseConfig.AppLoginAuthority}`,
                    knownAuthorities: [`${BaseConfig.AppLoginAuthority}`],
                    validateAuthority: false,
                    navigateToLoginRequestUrl: true,
                    redirectUri: `${BaseConfig.AppUrl}completelogin`,
                    postLogoutRedirectUri: `${BaseConfig.AppUrl}login`,
                },
                cache: {
                    cacheLocation: "sessionStorage",
                    storeAuthStateInCookie: true,
                    secureCookies: true
                }
            });

            this.app.handleRedirectPromise().then(response => {
                if (response) {
                    this.$store.dispatch("setIsProgressing", true);
                    this.handleResponse(response);
                }
            }).catch(error => {

                this.$vs.notify({
                    title: "Failed",
                    text: "Login failed, please try again",
                    color: "danger",
                    position: "top-center"
                });
                console.log("going to relogin");
                this.$store.dispatch("setIsProgressing", false);
                this.loginInProgress = false;
                this.$router.push("/relogin");
            });
        },
        async handleResponse(response) {
            this.$store.dispatch("completeLogin", response.account);
        }
    }
}
</script>

<style scoped>
.custom-logo-size {
    width: 40rem;
}
</style>
